// extracted by mini-css-extract-plugin
export var logo = "navigation-module--logo--be047";
export var navigationItemLink = "navigation-module--navigationItemLink--ab359";